var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"visible":!!_vm.userInfo,"size":"xl","hide-footer":"","title":_vm.userInfo.name},on:{"close":function($event){return _vm.$emit('close')},"hide":function($event){return _vm.$emit('close')}}},[(_vm.userInfo)?_c('div',[_c('profile',{key:_vm.userInfo.uuid,attrs:{"user-info":_vm.userInfo,"from-modal":true}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }